<template>
    <div
        class="review-widget-wrapper"
    >
        <h2>
            Would you like to save the details you give us?
        </h2>
        <PiSecure/>
        <p>
            By selecting 'Save my details', you allow Service NSW to save and use your personal information.
        </p>
        <LearnMoreAccordion/>
        <Button
            secondary
            @click="saveCustomerDetails"
        >
            Save my details
        </Button>
    </div>
</template>

<script>
    import Button from '../components/Button'
    import PiSecure from '../components/PiSecure'
    import gaTrackerAdapter from '../utils/gaTrackerAdapter'
    import LearnMoreAccordion from '../components/LearnMoreAccordion'

    export default {
        name: 'CkNewUpdateDetails',
        components: { Button, LearnMoreAccordion, PiSecure },
        props: {
            onSaveUpdate: {
                type: Function,
                default: () => {}
            },
        },
        methods: {
            saveCustomerDetails() {
                this.onSaveUpdate()
            },
            triggerGA(category, action, label = window.location.href) {
                gaTrackerAdapter.trackEvent(category, action, label)
            }
        }
    }
</script>
<style lang="css" src="../../node_modules/@servicensw/constants/constants.css"></style>
<style lang="css" scoped src="../../node_modules/@servicensw/base/dist/base.css"></style>
<style scoped lang="scss">
    .review-widget-wrapper {
        margin-bottom: 30px;
        border-bottom: 1px solid silver;
        border-top: 1px solid silver;
    }
</style>
